// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 3 ? "build-glob" : chunkId) + "-legacy." + {"3":"cb63192e","46":"e64c9d61","114":"f8234ebd","246":"5109e6f2","815":"1d5e9fa0","992":"d5ee55cc"}[chunkId] + ".js";
};